import { createAsyncThunk } from "@reduxjs/toolkit";
import { signIn, signUp } from "../APIs/authApis";
import { auth } from "../../../firebase/firebaseConfig";
import { getUserById } from "../../../firebase/queries";

// @Actions
export const signInAction = createAsyncThunk("auth/signIn", async (payload) => {
  return await signIn(payload);
});

export const logoutAction = createAsyncThunk("auth/logout", async () => {
  return await auth.signOut();
});

export const getCurrentUserAction = createAsyncThunk(
  "auth/getCurrentUser",
  async (payload, { getState }) => {
    const { auth } = getState();
    const user = auth.user;
    return await getUserById(user.id);
  }
);
